/** Propuesta Rolda × En Producción con MEM */

export const ROLDA_PROPOSAL = {
  eyebrow: 'Propuesta de visibilidad',
  title: 'Rolda × En Producción con MEM',
  concept: 'Autoridad en barbería y cuidado personal, con estilo y presencia multiplataforma.',
  intro:
    'Unimos la credibilidad editorial de En Producción con MEM con la voz técnica de Rolda: productos, tendencias y ritual de afeitado para el hombre que busca resultados visibles y confianza de marca.',
  planExplainSection: {
    overline: 'Estructura de la alianza',
    title: 'Qué incluye cada partida del plan',
    subtitle: '$100 + $100 + $80 = $280 USD/mes',
    body:
      'Streaming para recordación, producción creativa con prueba de producto en formatos cortos y un banner fijo en el portal TNO para dirigir tráfico a tus redes o puntos de venta.',
  },
  planExplainCards: [
    {
      service: 'Streaming',
      priceUsd: 100,
      icon: 'liveTv',
      details: [
        '12 spots diarios (360 al mes) en streaming en la señal 24/7 de TNO Network.',
        'Mensajes orientados a ritual de afeitado, línea de cuidado personal y disponibilidad de referencias Rolda.',
      ],
      benefit: 'Alta frecuencia para mantener el top of mind con la marca en el día a día de la audiencia.',
    },
    {
      service: 'Contenido UGC (creativo)',
      priceUsd: 100,
      icon: 'movieCreation',
      details: [
        '1 jornada de grabación al mes (en Media Lab o barbería aliada).',
        '4 clips cortos al mes (estilo TikTok/Reels) con antes y después usando productos Rolda.',
      ],
      benefit: 'Conexión real con público joven y profesional: prueba social y estética auténtica, no solo pauta tradicional.',
    },
    {
      service: 'Banners web',
      priceUsd: 80,
      icon: 'hub',
      details: [
        'Banner fijo en la sección de estilo de vida / negocios del portal web de TNO.',
        'Enlace o CTA hacia redes sociales, distribuidores o canal de compra que definan ustedes.',
      ],
      benefit: 'Tráfico directo a sus redes o puntos de venta desde un contexto editorial de estilo y negocios.',
    },
  ],
  planTableHeading: 'Resumen de inversión',
  planTitle: 'Plan de inversión mensual',
  planRows: [
    {
      service: 'Streaming',
      detail: '12 spots diarios (360 al mes) en streaming en la señal 24/7.',
      valueAdded: 'Alta frecuencia para mantener el top of mind.',
      amount: '$100',
    },
    {
      service: 'Contenido UGC (creativo)',
      detail:
        '1 jornada de grabación al mes (en Media Lab o barbería aliada). Creación de 4 clips cortos (estilo TikTok/Reels) mostrando el antes y después con productos Rolda.',
      valueAdded: 'Conexión real con el público joven y profesional.',
      amount: '$100',
    },
    {
      service: 'Banners web',
      detail: 'Banner fijo en la sección de estilo de vida / negocios de la web de TNO.',
      valueAdded: 'Tráfico directo a sus redes o puntos de venta.',
      amount: '$80',
    },
  ],
  planTotalLabel: 'Plan de autoridad y estilo',
  planTotalAmount: '$280',
};
